import { type AgentSessionResponse } from '@air/server-sdk';

/** Sessions still working or waiting on the user — worth polling the list while My Tasks is open. */
export const isWorkspaceAgentSessionNotIdle = (session: Pick<AgentSessionResponse, 'status'>): boolean =>
  session.status === 'processing' || session.status === 'inputRequested';
